"use client"

import ImageComponent from "@/components/ui/ImageComponent"
import { Button } from "@heroui/react"

interface MultiBeforeAndAfterImageProps {
  image_url: string
  alt_name: string
}

const MultiBeforeAndAfterImage = ({
  image_url,
  alt_name,
}: MultiBeforeAndAfterImageProps) => {



  return (
    <div
      className="mx-0 md:mx-3 rounded-3xl overflow-hidden select-none"
    >
      <div
        className="relative w-auto h-auto pointer-events-none"
      >
        <ImageComponent
          url={image_url}
          img_title={`${alt_name}`}
        />
        <Button className="absolute top-10 -translate-y-1/2 left-2 z-20 text-sm! md:text-lg! px-4! bg-white text-textf1 rounded-full">
          Before
        </Button>

        {/* AFTER TAG */}
        <Button className="absolute top-10 -translate-y-1/2 right-2 z-20 text-sm! md:text-lg! px-4! text-white bg-textf1 rounded-full">
          After
        </Button>
      </div>

      {/* BEFORE TAG */}


    </div>
  )
}

export default MultiBeforeAndAfterImage;
